import DemoAddressSearchBar from './DemoAddressSearchBar'

export default DemoAddressSearchBar
